export default  {
    name: state => state.info.name,
    avatar: state => state.info.avatar,
    companyname: state => state.info.companyname,
    vip_type: state=> state.info.vip_type,
    vip_log: state=> state.info.vip_log,
    puhuiyun:state=>state.info.puhuiyun,
    t_id:state=>state.info.t_id,
    tw_id:state=>state.info.tw_id,

}
